"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ButtonDropDown = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _ArrowDropDown = _interopRequireDefault(require("@material-ui/icons/ArrowDropDown"));

var _Button = _interopRequireDefault(require("../Button"));

var _Menu = _interopRequireDefault(require("../Menu/Menu"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("./styles");

var _styles2 = require("@material-ui/core/styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ButtonDropDown = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ButtonDropDown, _Component);

  var _super = _createSuper(ButtonDropDown);

  function ButtonDropDown() {
    var _this;

    (0, _classCallCheck2.default)(this, ButtonDropDown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props = _this.props,
          options = _this$props.options,
          id = _this$props.id,
          className = _this$props.className,
          classes = _this$props.classes,
          fullWidth = _this$props.fullWidth,
          color = _this$props.color;
      var renderedOptions = (0, _toConsumableArray2.default)(options);
      var defaultOption = renderedOptions.shift();
      var calculatedColor = defaultOption ? defaultOption.color || color : color;
      var disabled = defaultOption && "disabled" in defaultOption && defaultOption.disabled;
      var primaryClassName = defaultOption && "className" in defaultOption ? defaultOption.className : undefined;
      return defaultOption ? /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)("prmbl-buttonDropDown", classes.root, className, (0, _defineProperty2.default)({}, classes.fullWidth, fullWidth)),
        id: id
      }, /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({
        color: calculatedColor
      }, defaultOption, {
        fullWidth: fullWidth,
        className: (0, _classnames.default)("prmbl-buttonDropDown-primary", (0, _defineProperty2.default)({}, primaryClassName, primaryClassName))
      })), renderedOptions.length > 0 && /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _classnames.default)(classes.menuButtonRoot, disabled ? classes.disabled : classes[calculatedColor])
      }, /*#__PURE__*/_react.default.createElement(_Menu.default, {
        id: "".concat(id, "-dropDownMenu"),
        className: (0, _classnames.default)("prmbl-buttonDropDown-menu"),
        classes: {
          item: classes.itemWrap,
          paper: classes.buttonMenu,
          button: classes.menuButton
        },
        icon: /*#__PURE__*/_react.default.createElement(_ArrowDropDown.default, null),
        type: "topbar",
        items: renderedOptions.map(function (option, index) {
          return {
            display: /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({
              color: color,
              className: classes.menuItem,
              fullWidth: true
            }, option)),
            action: function action() {// do nothing
            }
          };
        })
      }))) : null;
    });
    return _this;
  }

  return (0, _createClass2.default)(ButtonDropDown);
}(_react.Component);

exports.ButtonDropDown = ButtonDropDown;
(0, _defineProperty2.default)(ButtonDropDown, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes.default.string,

  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * If `true`, the ButtonDropDown will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The color of the component. It supports those those theme colors
   * that make sense for this component
   */
  color: _propTypes.default.oneOf(["default", "primary", "secondary", "inherit"]),

  /**
   * An array of `Button` props
   */
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    /**
     * The html id
     */
    id: _propTypes.default.string,

    /**
     * The content of the button.
     */
    children: _propTypes.default.node.isRequired,

    /**
     * Override the component rendered
     */
    component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

    /**
     * If `true`, the button will be disabled.
     */
    disabled: _propTypes.default.bool,

    /**
     * The URL to link to when the button is clicked. If desired, an `a` element will
     * be used as the root node.
     */
    href: _propTypes.default.string,

    /**
     * Callback to execute when the button is pressed
     */
    onClick: _propTypes.default.any,

    /**
     * The size of the button. `small` is equivalent to the dense button styling.
     */
    size: _propTypes.default.oneOf(["small", "medium", "large"]),

    /**
     * The type of button to render
     */
    type: _propTypes.default.oneOf(["default", "icon"]),

    /**
     * The style of button.
     */
    variant: _propTypes.default.oneOf(["contained", "outlined", "text"]),

    /**
     * Set true to open the href in a new window.
     */
    openInNewWindow: _propTypes.default.bool,

    /**
     * The color type.
     */
    color: _propTypes.default.oneOf(["default", "primary", "secondary"])
  })).isRequired,

  /**
   * Classes to apply to the root
   */
  className: _propTypes.default.string
});

var _default = (0, _styles2.withStyles)(_styles.styles)(ButtonDropDown);

exports.default = _default;